// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3zT2g","loaderOuter":"PageOverlayLoader_loaderOuter__2eezQ"};